/* mt-landing.js - Zahlen der Landings aus dem Filter-Index (Landing-Review 30.09.2026, B12/B13).
   Jede Zahl auf der Landing kommt aus derselben Quelle wie das Raster der Zielseite: Elemente mit data-lp-z="<Ziel>"
   (Einstiegsfelder, Kacheln, Kopf-Links, Knöpfe, Zeitleiste) bekommen die Artikelzahl des Ziels inkl. ?mtf_-Filter.
   Felder, Kacheln und Knöpfe ohne Treffer werden ausgeblendet. Index: dasselbe Promise/derselbe Speicher wie assets/mt-filter.js. */
(function () {
  var lp = document.querySelector('.mt-lp');
  if (!lp) return;
  var els = Array.prototype.slice.call(lp.querySelectorAll('[data-lp-z]'));
  if (!els.length) { lp.setAttribute('data-lp-zahlen', 'fertig'); return; }
  var idxUrl = lp.getAttribute('data-idx') || '';
  var cfg = document.getElementById('mt-filter-config');
  try { if (cfg) { var c = JSON.parse(cfg.textContent); if (c.indexUrl) idxUrl = c.indexUrl; } } catch (e) {}
  var CK = 'mtf_idx_' + ((idxUrl.match(/v=(\d+)/) || ['', '0'])[1]);

  function selbst(cb) {
    try { var c = sessionStorage.getItem(CK); if (c) { cb(JSON.parse(c)); return; } } catch (e) {}
    fetch(idxUrl).then(function (r) { return r.json(); }).then(function (d) {
      try { sessionStorage.setItem(CK, JSON.stringify(d)); } catch (e) {}
      cb(d);
    }).catch(function () { lp.setAttribute('data-lp-zahlen', 'fehler'); });
  }
  function laden(cb) {
    if (window.MT_IDX_P) { window.MT_IDX_P.then(cb); return; }
    if (!cfg) { selbst(cb); return; }
    var n = 0, t = setInterval(function () {
      if (window.MT_IDX_P) { clearInterval(t); window.MT_IDX_P.then(cb); }
      else if (++n > 30) { clearInterval(t); selbst(cb); }
    }, 50);
  }
  // Spiegel von deliveryInfo()/vals() in assets/mt-filter.js
  function status(p) {
    if (p.av === 1) return 'Sofort lieferbar';
    if (p.au === 1) return 'Auslaufend';
    if (p.sl === 'preorder' || p.pre === 1) return 'Vorbestellung';
    if (p.sl === 'on_order') return 'Bald verfügbar';
    if (p.sl === 'bald_verfuegbar') return 'Bald verfügbar'; // 30.10.2026 (T-167)
    if (p.sl === 'made_to_order') return 'Auf Bestellung gefertigt';
    if (p.sl === 'auf_bestellung') return 'Auf Bestellung';
    if (p.sl === 'available') return 'Sofort lieferbar';
    return 'Nicht auf Lager';
  }
  function vals(p, k) {
    if (k === 'v') return p.v ? [p.v] : [];
    if (k === 'pt') return p.pt ? [p.pt] : [];
    if (k === 'av') return [status(p)];
    return (p.f && p.f[k]) || [];
  }
  function zaehlen(d, href) {
    var u; try { u = new URL(href, location.origin); } catch (e) { return null; }
    var m = u.pathname.match(/\/collections\/([^\/?#]+)/); if (!m) return null;
    var h = decodeURIComponent(m[1]), pool;
    if (h === 'all') pool = d.products;
    else {
      var ci = -1; for (var i = 0; i < d.cols.length; i++) if (d.cols[i].h === h) { ci = i; break; }
      if (ci < 0) return null;
      pool = d.products.filter(function (p) { return p.c && p.c.indexOf(ci) >= 0; });
    }
    var f = {};
    u.searchParams.forEach(function (v, k) { if (k.indexOf('mtf_') === 0 && ['mtf_sort', 'mtf_pmin', 'mtf_pmax'].indexOf(k) < 0) f[k.slice(4)] = v.split('~').filter(Boolean); });
    var ks = Object.keys(f);
    return pool.filter(function (p) { return ks.every(function (k) { var pv = vals(p, k); return f[k].some(function (x) { return pv.indexOf(x) >= 0; }); }); }).length;
  }
  // 30.09.2026: Handy-Spalten der Fahnen-/Logo-Raster mit der ECHTEN Anzahl (nach dem Ausblenden) - nie eine Einzelkachel in der letzten Reihe.
  function spalten() {
    Array.prototype.forEach.call(lp.querySelectorAll('.mtk-grid--fahne, .mtk-grid--logo'), function (g) {
      var n = Array.prototype.filter.call(g.children, function (k) { return !k.classList.contains('is-extra'); }).length;
      var kand = g.classList.contains('mtk-grid--logo') ? [3, 2, 4] : (g.hasAttribute('data-lang') ? [3, 2, 4] : [4, 3, 2]);
      var w = 0; for (var i = 0; i < kand.length; i++) { if (n <= kand[i] || n % kand[i] !== 1) { w = kand[i]; break; } }
      g.classList.toggle('mtk-grid--m-breit', !w);
      g.classList.toggle('mtk-grid--eng', w === 4 && g.hasAttribute('data-lang')); // lange Namen in 4 Spalten: kleinere Schrift statt Einzelkachel (30.09.: 4 lange Namen = 2x2, sonst abgeschnitten)
      g.style.setProperty('--k-cols-m', w || kand[0]);
    });
  }
  // 30.09.2026: lange Fahnen-Namen in 4 Spalten (z. B. „Großbritannien“ bei 375 px) so weit verkleinern, bis sie in die Kachel passen - nie abschneiden
  function einpassen() {
    Array.prototype.forEach.call(lp.querySelectorAll('.mtk-grid--eng .mtk-n'), function (t) {
      t.style.fontSize = ''; var fs = parseFloat(getComputedStyle(t).fontSize), min = 8;
      while (t.scrollWidth > t.clientWidth + 1 && fs > min) { fs -= 0.25; t.style.fontSize = fs + 'px'; }
    });
  }
  var einpassenT; window.addEventListener('resize', function () { clearTimeout(einpassenT); einpassenT = setTimeout(einpassen, 150); });
  spalten(); einpassen();
  laden(function (d) {
    els.forEach(function (el) {
      var n = zaehlen(d, el.getAttribute('data-lp-z'));
      if (n == null) return;
      el.setAttribute('data-lp-n', n);
      if (el.classList.contains('lp-e')) {
        var z = el.querySelector('.lp-e-n'); if (z) z.textContent = n > 0 ? n + ' ' + (z.getAttribute('data-einheit') || '') : '';
        if (n === 0 && !el.classList.contains('lp-e--1')) el.remove();
      } else if (el.classList.contains('lp-kopf-link')) {
        var t = el.querySelector('.lp-kopf-lt');
        if (t) t.textContent = /\(\d+\)/.test(t.textContent) ? t.textContent.replace(/\(\d+\)/, '(' + n + ')') : t.textContent + ' (' + n + ')';
      } else if (el.classList.contains('mtk')) {
        var c = el.querySelector('.mtk-c'); if (c) c.textContent = n > 0 ? n + ' ' + (c.getAttribute('data-einheit') || '') : '';
        // B20: Filter-Kacheln unter 3 Artikeln entfallen. Gestaltung C 01.10.: Kacheln ohne Filter zählen jetzt auch hier - die entfallen nur bei 0
        if (!el.classList.contains('mtk--sammel') && (el.getAttribute('data-lp-z').indexOf('mtf_') >= 0 ? n < 3 : n === 0)) el.remove();
      } else if (el.classList.contains('lp-chip')) {
        if (n === 0) el.remove();
      } else {
        var cc = el.querySelector('.mtk-c'); if (cc) cc.textContent = n + ' ' + (cc.getAttribute('data-einheit') || '');
      }
    });
    spalten(); einpassen();
    // Einstiegsleiste: Spaltenzahl nach dem Ausblenden
    var g = lp.querySelector('.lp-einstieg-g');
    // Gestaltung C (01.10.2026, Handy-Audit C3): Felder mit derselben Zahl wie „Alle Produkte“ zeigen dieselbe Auswahl - doppelt, entfallen
    // (12 mm: „2. Weltkrieg in 12 mm“ 33 = alle 33; Starter-Liste: „Sets mit Regeln“ 31 = alle 31). Bleibt nur ein Feld, entfällt die Leiste.
    if (g) {
      var e1 = g.querySelector('.lp-e--1'), n1 = e1 ? e1.getAttribute('data-lp-n') : null;
      if (n1 && +n1 > 0) Array.prototype.forEach.call(g.querySelectorAll('.lp-e'), function (e) { if (e !== e1 && e.getAttribute('data-lp-n') === n1) e.remove(); });
      // Reservefeld „Sofort lieferbar“ nur, wenn sonst genau 3 Felder bleiben (keine halbe Zeile am Handy)
      var res = g.querySelector('.lp-e--reserve');
      if (res) { if (g.querySelectorAll('.lp-e:not(.lp-e--reserve)').length === 3 && +(res.getAttribute('data-lp-n') || 0) > 0) res.classList.remove('lp-e--reserve'); else res.remove(); }
      var en = g.querySelectorAll('.lp-e').length; g.style.setProperty('--e-n', en); g.setAttribute('data-e-n', en);
      if (en < 2) { var nav = g.closest('.lp-einstieg'); if (nav) nav.remove(); }
    }
    lp.setAttribute('data-lp-zahlen', 'fertig');
  });
})();
